import React from "react";
import PropTypes from "prop-types";
import { merge } from "lodash";
import pojo from "LIB/pojos";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Form from "./Form";

const initialValues = company =>
  merge(
    pojo(company).pick(
      "imperfect_trace",
      "no_pmas_accepted",
      "no_ders_accepted",
      "warranty_minimum",
      "unaccepted_trace_types"
    ),
    company.unaccepted_trace_types.reduce((obj, k) => {
      obj[`trace_type_${k}`] = true;
      return obj;
    }, {})
  );

export default function EditCustomerRestrictions({ open, close, company }) {
  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Customer Restrictions</h4>
      </Header>
      <Form
        company={company}
        close={close}
        initialValues={initialValues(company)}
        enableReinitialize
      />
    </Modal>
  );
}

EditCustomerRestrictions.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  company: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/CustomerRestrictionsTable/EditCustomerRestrictions.jsx